// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__6T8Ka","errorLogs":"styles_errorLogs__23vdd"};